import React, { FC, useRef } from 'react';
import Box from '@/components/UI/box/Box';
import useIntersection from '@/hooks/useIntersection';
import dynamic from 'next/dynamic';
import SimilarProductsContainerSkeleton from './similarProducts/similarProductsContainerSkeleton/SimilarProductsContainerSkeleton';
const SimilarProducts = dynamic(() => import('@/components/houses/_reusable/houseInfo/similarHousesContainer/similarProducts/SimilarProducts'), {
  ssr: false,
  loading: () => <SimilarProductsContainerSkeleton />
});
type SimilarHousesContainerProps = {
  bookableStatus: string;
  parentId: number;
};
const SimilarHousesContainer: FC<SimilarHousesContainerProps> = ({
  bookableStatus,
  parentId
}) => {
  const ref = useRef<HTMLElement | null>(null);
  const isVisible = useIntersection(ref, '100px', true);
  if (process.env.OFFLINE_MODE === 'true') return null;
  return <Box ref={ref} component={'section'} data-sentry-element="Box" data-sentry-component="SimilarHousesContainer" data-sentry-source-file="SimilarHousesContainer.tsx">
      {isVisible && <SimilarProducts bookableStatus={bookableStatus} parentId={parentId} />}
    </Box>;
};
export default SimilarHousesContainer;